import { Provider } from '@angular/core';

/**
 * services
 */
import { FacilityApiService } from '../api';
import { FacilityService } from '../facility.service';
import { FacilityFormService } from '../facility-form';

/**
 * Route-level provider array for the Facility sub-module.
 * Register this array in the `providers` field of the facility route definition
 * to scope all three services to the facility route and its children.
 *
 * @example
 * ```typescript
 * {
 *   path: 'facility',
 *   loadComponent: () => import('./facility.component').then(c => c.FacilityComponent),
 *   providers: FacilityServiceProviders,
 * }
 * ```
 */
export const FacilityServiceProviders: Provider[] = [
    FacilityApiService,
    FacilityFormService,
    FacilityService,
];
